import { useEffect } from "react";

export const useHideOnScroll = (params) => {
  const { className, hideOnScroll, setState } = params;
  useEffect(
    function hideOnScrollEffect() {
      function closeDropDown(e) {
        if (!e.target.closest(`.${className}`)) {
          setState();
        }
      }
      if (hideOnScroll) {
        document.addEventListener("wheel", closeDropDown);
      }
      return () => {
        document.removeEventListener("wheel", closeDropDown);
      };
    },
    // since setState is a function, it will change on every render causing infinite loop hence we are not adding it to dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hideOnScroll, className]
  );

  return true;
};
